import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';

const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '常见问题', href: '#faq' },
  { label: '热播榜单', href: '#ranking' },
  { label: '观众热评', href: '#comments' },
  { label: '精选推荐', href: '#media' },
  { label: '影视分类', href: '#cards' },
];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-18">
            <a href="#hero" className="flex items-center gap-2 cursor-pointer">
              <span className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
                小辣椒影院
              </span>
            </a>
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="whitespace-nowrap px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-background-100 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-b border-background-200/70">
            <div className="px-4 py-3 space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>

      <main>
        <HeroSection />
        <CardsSection />
        <FaqSection />
        <RankingSection />
        <MediaSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <AppSection />
      </main>

      <footer id="footer" className="bg-foreground-900 text-background-50/80">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-2">
              <a href="#hero" className="inline-block mb-4 cursor-pointer">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
                  小辣椒影院
                </span>
              </a>
              <p className="text-sm text-background-50/60 leading-relaxed max-w-md mb-4">
                小辣椒影院是一个免费高清影视在线平台，提供最新电影、热播电视剧、热门综艺和动漫番剧的在线观看服务。
                画质清晰不卡顿，每日更新最新资源，无需注册即可免费享受流畅的观影体验。
              </p>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">快速导航</h4>
              <div className="space-y-2.5">
                {navLinks.slice(0, 4).map((link) => (
                  <a key={link.label} href={link.href} className="block text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">合作伙伴</h4>
              <p className="text-sm text-background-50/40 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>
          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; 2024 小辣椒影院. 本站所有资源均来自互联网，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
              <a href="#faq" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              <a href="#contact" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}